// Actions
export const CALL_LOADING = 'CALL_LOADING';

// Mutations
export const MUTATE_LOADING = 'MUTATE_LOADING';
